/* unplugin-vue-components disabled */import script from "./Footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Footer.vue?vue&type=script&lang=ts&setup=true"

import "./Footer.vue?vue&type=style&index=0&id=a7b089e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7b089e4"]])

export default __exports__